import { Q as head, R as slot, P as pop, N as push } from "../../chunks/index.js";
import { a as analytics } from "../../chunks/analytics.js";
function _layout($$payload, $$props) {
  push();
  analytics.page();
  head($$payload, ($$payload2) => {
    $$payload2.out += `<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,1,200">`;
  });
  $$payload.out += `<div id="app" class="fade-in bg-white w-full h-full overflow-x-hidden"><!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!----></div>`;
  pop();
}
export {
  _layout as default
};
